/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

const defaults: Record<string, string> = {
    // menu
    bold: 'Bold',
    italic: 'Italic',
    code: 'Code',
    underline: 'Underline',
    strike: 'Strike',
    blockquote: 'Blockquote',
    bullet_list: 'Bullet List',
    ordered_list: 'Ordered List',
    heading: 'Heading',
    h1: 'Header 1',
    h2: 'Header 2',
    h3: 'Header 3',
    h4: 'Header 4',
    h5: 'Header 5',
    h6: 'Header 6',
    fontGroup: '14',
    fontSize8: '8',
    fontSize9: '9',
    fontSize10: '10',
    fontSize11: '11',
    fontSize12: '12',
    fontSize13: '13',
    fontSize14: '14',
    fontSize15: '15',
    fontSize16: '16',
    fontSize17: '17',
    fontSize18: '18',
    fontSize19: '19',
    fontSize20: '20',
    fontSize21: '21',
    fontSize22: '22',
    fontSize23: '23',
    fontSize24: '24',
    align_left: 'Left Align',
    align_center: 'Center Align',
    align_right: 'Right Align',
    align_justify: 'Justify',
    text_color: 'Text Color',
    background_color: 'Background Color',
    insertLink: 'Insert Link',
    removeLink: 'Remove Link',
    insertImage: 'Insert Image',
    insertTable: 'Insert Table',

    // pupups, forms, others...
    url: 'URL',
    text: 'Text',
    openInNewTab: 'Open in new tab',
    insert: 'Insert',
    altText: 'Alt Text',
    title: 'Title',
    remove: 'Remove'
};

export type LocalsKeys = keyof typeof defaults;

class Locals {
    /**
     * Locals.
     */
    locals = defaults;

    /**
     * Default constructor.
     * 
     * @param newLocals New locals.
     */
    constructor(newLocals: Partial<Record<LocalsKeys, string>> = {}) {
        this.locals = Object.assign({}, defaults, newLocals);
    }

    /**
     * Getter function.
     * 
     * @param key String.
     * @returns String.
     */
    get = (key: string): string => {
        return this.locals[key] ?? '';
    }
}

export default Locals;
